import { Injectable } from '@angular/core';
import * as enquire from 'enquire.js';

@Injectable()
export class EnquiryService {

  register(query, handler) {
    enquire.register(query, handler);
  }

 }



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/media-query/enquiry.service.ts